<template>
  <div class="ma-4 px-4">
    <searchBar
      @add="(dialog = true), (editMode = false)"
      @updateSearch="(v) => (search = v)"
      headerText="Course Unit"
    />

    <v-row>
      <v-col cols="12">
        <v-sheet outlined>
          <v-data-table
            :headers="headers"
            :search="search"
            :items="sections"
            :custom-filter="customFilter"
            fixed-header
            class="secondary row-height-50"
          >
            <template #[`item.course_id`]="{ item }">
              {{ getCourse(item) }}
            </template>
            <template #[`item.action`]="{ item }">
              <v-icon small class="mr-2" color="accent" @click="edit(item)">
                mdi-pencil
              </v-icon>
            </template>
            <template #[`item.description`]="{ item }">
              <v-chip
                small
                @click="showData(item.name, item.description, 'Description')"
              >
                View</v-chip
              >
            </template>
          </v-data-table>
        </v-sheet>
      </v-col>
    </v-row>
    <v-dialog v-model="dialog" width="800" persistent scrollable>
      <formDialog
        v-if="dialog"
        @closeDialog="dialog = false"
        @create="createSection"
        @update="updateSection"
        :section="section"
        :courses="courses"
        :edit="editMode"
      />
    </v-dialog>
    <v-dialog v-model="showDialog" max-width="600" persistent scrollable>
      <v-card class="secondary">
        <v-card-title class="primary white--text"
          >{{ selectedItem.name }} - {{ selectedItem.content_name }}
          <v-spacer></v-spacer>
          <v-btn small icon @click="showDialog = false">
            <v-icon small color="secondary">mdi-close</v-icon>
          </v-btn></v-card-title
        >
        <v-divider></v-divider>
        <v-card-text class="mt-3 reset-card-text">
          <div v-html="selectedItem.description"></div>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import formDialog from "@/components/course/units.vue";
import searchBar from "@/components/searchBar.vue";
import { courseUnitHeaders } from "@/constants/headers";
export default {
  components: {
    formDialog,
    searchBar,
  },
  data() {
    return {
      headers: courseUnitHeaders,
      dialog: false,
      editMode: false,
      deleteDialog: false,
      search: "",
      sections: [],
      courses: [],
      section: {},
      selectedItem: {},
      showDialog: false,
    };
  },
  watch: {},
  computed: {},
  created() {
    this.course_id = this.$route.query.id;
    this.course_name = this.$route.query.name;
    this.$store.commit("setBreadcrumbs", [
      { text: "Courses", to: { name: "Courses" } },
      {
        text: this.course_name,
        to: {
          path: "/course_sections",
          query: { id: this.course_id, name: this.course_name },
        },
      },
      { text: "Units" },
    ]);
    this.initialise();
  },
  methods: {
    async initialise() {
      const [sections, courses] = await Promise.all([
        this.$axios.get("course_sections"),
        this.$axios.get("courses"),
      ]);

      const sectionData = sections.data.data;
      this.courses = courses.data.data;
      this.sections = sectionData
        .filter((s) => s.course_id == this.course_id)
        .sort((a, b) => b.id - a.id);
    },
    async createSection(data) {
      await this.$axios
        .post("course_sections", { course_section: data })
        .then(() => {
          this.$store.commit("showSnackbar", {
            message: "Course Unit created successfully",
            color: "success",
          });
          this.resetValues();
          this.initialise();
        })
        .catch(async (error) => {
          const errorMessage = await this.$store.dispatch(
            "throwError",
            error.response
          );
          this.$store.commit("showSnackbar", {
            message: errorMessage,
            color: "error",
          });
        });
    },
    async updateSection(data) {
      await this.$axios
        .put("course_sections/" + data.id, { course_section: data })
        .then(() => {
          this.$store.commit("showSnackbar", {
            message: "Course Unit updated successfully",
            color: "success",
          });
          this.resetValues();
          this.initialise();
        })
        .catch(async (error) => {
          const errorMessage = await this.$store.dispatch(
            "throwError",
            error.response
          );
          this.$store.commit("showSnackbar", {
            message: errorMessage,
            color: "error",
          });
        });
    },

    edit(item) {
      this.section = { ...item };
      this.editMode = true;
      this.dialog = true;
    },
    resetValues() {
      this.editMode = false;
      this.dialog = false;
      this.deleteDialog = false;
      this.section = {};
    },
    getCourse(item) {
      return this.courses.find((x) => x.id == item.course_id)?.name;
    },
    showActiveStatus(value) {
      return value ? "Active" : "Inactive";
    },
    showData(name, content, content_name) {
      this.showDialog = true;
      this.selectedItem.description = content;
      this.selectedItem.name = name;
      this.selectedItem.content_name = content_name;
    },
    customFilter(value, search, item) {
      if (!search) return true;
      const course = this.getCourse(item);
      return (
        JSON.stringify(item).toLowerCase().includes(search.toLowerCase()) ||
        course.toLowerCase().includes(search.toLowerCase())
      );
    },
  },
};
</script>

<style></style>
